import { get } from 'src/axios/post'
import { reset, wait } from 'src/store'

const loggedInStates = () => {
  return [
    'onboardingMessage',
    'needsReloading',
    'loading'
  ]
}

const defaultStates = () => {
  return {
    onboardingMessage: null,
    needsReloading: true,
    loading: false
  }
}

export default {
  namespaced: true,
  state: defaultStates(),
  mutations: {
    reset (state) {
      reset(state, loggedInStates(), defaultStates())
    },
    setLoading (state, val) {
      state.loading = Boolean(val)
    },
    setNeedsReloading (state, val) {
      state.needsReloading = Boolean(val)
    },
    setOptions (state, payload) {
      state.onboardingMessage = payload.onboarding_message || null
      state.needsReloading = false
    }
  },
  actions: {
    async getOptions ({ commit, state }) {
      if (state.loading || !state.needsReloading) {
        if (state.loading) {
          await wait(state, 'loading')
        }
        return
      }
      commit('setLoading', true)
      const { status, payload } = await get('v1/register/business/options/setupWizard')
      commit('setLoading', false)
      if (status === 'success') {
        commit('setOptions', payload)
      }
    }
  },
  getters: {
    getOnboardingMessage: state => state.onboardingMessage,
    needsReloading: state => state.needsReloading,
    isLoading: state => state.loading
  }
}
